import { render, staticRenderFns } from "./forget_pwd.vue?vue&type=template&id=79d7cad8&scoped=true"
import script from "./forget_pwd.vue?vue&type=script&lang=js"
export * from "./forget_pwd.vue?vue&type=script&lang=js"
import style0 from "./forget_pwd.vue?vue&type=style&index=0&id=79d7cad8&prod&scoped=true&lang=css"
import style1 from "./forget_pwd.vue?vue&type=style&index=1&id=79d7cad8&prod&lang=css"
import style2 from "./forget_pwd.vue?vue&type=style&index=2&id=79d7cad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d7cad8",
  null
  
)

export default component.exports